<template>
  <div id="scan" v-loading="loading">
    <el-tabs type="border-card">
      <el-tab-pane :label="label">
        <el-form ref="scanForm" v-show="showFlag" label-width="90px">
          <el-form-item label="商户名称">
            <el-input v-model="scanForm.store_name"></el-input>
          </el-form-item>
          <el-form-item label="电话号码">
            <el-input v-model="scanForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码">
            <el-input v-model="scanForm.id_card_no"></el-input>
          </el-form-item>
          <el-form-item label="上传照片">
            <el-upload
              class="upload-demo"
              action="/"
              :before-upload="idPositiveUpload"
              :before-remove="handleRemove"
              :file-list="scanForm.id_card_positive_img"
              list-type="picture">
              <el-button size="small" type="primary">身份证正面照片</el-button>
              <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传照片">
            <el-upload
              class="upload-demo"
              action="/"
              :before-upload="idBackUpload"
              :before-remove="handleRemove"
              :file-list="scanForm.id_card_back_img"
              list-type="picture">
              <el-button size="small" type="primary">身份证反面照片</el-button>
              <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传照片">
            <el-upload
              class="upload-demo"
              action="/"
              :before-upload="bankPositiveUpload"
              :before-remove="handleRemove"
              :file-list="scanForm.bank_card_positive_img"
              list-type="picture">
              <el-button size="small" type="primary">银行卡正面照片</el-button>
              <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传照片">
            <el-upload
              class="upload-demo"
              action="/"
              :before-upload="bankBackUpload"
              :before-remove="handleRemove"
              :file-list="scanForm.bank_card_back_img"
              list-type="picture">
              <el-button size="small" type="primary">银行卡反面照片</el-button>
              <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传照片">
            <el-upload
              class="upload-demo"
              action="/"
              :before-upload="idHandUpload"
              :before-remove="handleRemove"
              :file-list="scanForm.id_card_hand_in_img"
              list-type="picture">
              <el-button size="small" type="primary">手持身份证半身照片</el-button>
              <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="scanAdd()">确认申请</el-button>
          </el-form-item>
        </el-form>
        <el-form ref="scanDetails" v-show="!showFlag" label-width="100px">
          <div v-show="qrFlag">
            <el-form-item label="商户名称">
              <el-input v-model="scanDetails.name" readonly></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input v-model="scanDetails.telephone" readonly></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="scanDetails.id_card_no" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请进度">
              <el-input v-model="scanDetails.statusTxt" readonly></el-input>
            </el-form-item>
            <el-form-item v-show="scanDetails.status == 2" label="失败原因">
              <el-input v-model="scanDetails.status_reason" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请时间">
              <el-input v-model="scanDetails.created_at" readonly></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-upload
                class="upload-demo"
                action="/"
                :before-remove="handleRemove"
                :file-list="[{name: '身份证正面照片',url: scanDetails.id_card_positive}]"
                list-type="picture">
              </el-upload>
            </el-form-item>
            <el-form-item label="">
              <el-upload
                class="upload-demo"
                action="/"
                :before-remove="handleRemove"
                :file-list="[{name: '身份证反面照片',url: scanDetails.id_card_back}]"
                list-type="picture">
              </el-upload>
            </el-form-item>
            <el-form-item label="">
              <el-upload
                class="upload-demo"
                action="/"
                :before-remove="handleRemove"
                :file-list="[{name: '银行卡正面照片',url: scanDetails.bank_card_positive}]"
                list-type="picture">
              </el-upload>
            </el-form-item>
            <el-form-item label="">
              <el-upload
                class="upload-demo"
                action="/"
                :before-remove="handleRemove"
                :file-list="[{name: '身份证反面照片',url: scanDetails.bank_card_back}]"
                list-type="picture">
              </el-upload>
            </el-form-item>
            <el-form-item label="">
              <el-upload
                class="upload-demo"
                action="/"
                :before-remove="handleRemove"
                :file-list="[{name: '手持身份证半身照',url: scanDetails.id_card_hand_in}]"
                list-type="picture">
              </el-upload>
            </el-form-item>
            <el-form-item v-show="scanDetails.status == 2">
              <el-button type="primary" @click="showFlag = true" >重新申请</el-button>
            </el-form-item>
          </div>
          <div class="qr-box" v-show="!qrFlag">
            <a @click="downloadQr(scanDetails.scan_qr_img,$event)">
              <img :src="scanDetails.scan_qr_img" width="200" height="200" alt="">
              <br><br>
              <span class="tips">点击图片下载二维码</span>
            </a>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Scan',
  data () {
    return {
      loading: false,
      showFlag: true,
      qrFlag: true,
      label: '二维码申请',
      scanForm: {
        store_name: '',
        phone: '',
        id_card_no: '',
        id_card_positive_img: [],
        id_card_back_img: [],
        bank_card_positive_img: [],
        bank_card_back_img: [],
        id_card_hand_in_img: []
      },
      scanDetails: {}
    }
  },
  created() {
    this.getscanInfo();
  },
  methods: {
    handleRemove(file, fileList) {
      this.$message.error('不支持删除操作');
      return false;
    },
    idPositiveUpload(file) {
      var _this = this;
      var params = new FormData();
      params.append('file',file,"file_"+Date.parse(new Date())+".png");
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/upload',
        data: params
      }).then((res) => {
        if(res.data.code == 200) {
          _this.scanForm.id_card_positive_img = [
            {
              name: '身份证正面照片',
              url: res.data.data.url
            }
          ];
        } else {
        }
      });
    },
    idBackUpload(file) {
      var _this = this;
      var params = new FormData();
      params.append('file',file,"file_"+Date.parse(new Date())+".png");
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/upload',
        data: params
      }).then((res) => {
        if(res.data.code == 200) {
          _this.scanForm.id_card_back_img = [
            {
              name: '身份证反面照片',
              url: res.data.data.url
            }
          ];
        } else {
        }
      });
    },
    bankPositiveUpload(file) {
      var _this = this;
      var params = new FormData();
      params.append('file',file,"file_"+Date.parse(new Date())+".png");
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/upload',
        data: params
      }).then((res) => {
        if(res.data.code == 200) {
          _this.scanForm.bank_card_positive_img = [
            {
              name: '银行卡正面照片',
              url: res.data.data.url
            }
          ];
        } else {
        }
      });
    },
    bankBackUpload(file) {
      var _this = this;
      var params = new FormData();
      params.append('file',file,"file_"+Date.parse(new Date())+".png");
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/upload',
        data: params
      }).then((res) => {
        if(res.data.code == 200) {
          _this.scanForm.bank_card_back_img = [
            {
              name: '银行卡反面照片',
              url: res.data.data.url
            }
          ];
        } else {
        }
      });
    },
    idHandUpload(file) {
      var _this = this;
      var params = new FormData();
      params.append('file',file,"file_"+Date.parse(new Date())+".png");
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/upload',
        data: params
      }).then((res) => {
        if(res.data.code == 200) {
          _this.scanForm.id_card_hand_in_img = [
            {
              name: '手持身份证半身照',
              url: res.data.data.url
            }
          ];
        } else {
        }
      });
    },
    scanAdd() {
      var _this = this;
      _this.loading = true;
      var params = new URLSearchParams();
      var scanForm = _this.scanForm;
      params.append('store_name',scanForm.store_name);
      params.append('phone',scanForm.phone);
      params.append('id_card_no',scanForm.id_card_no);
      params.append('id_card_positive_img',scanForm.id_card_positive_img[0].url);
      params.append('id_card_back_img',scanForm.id_card_back_img[0].url);
      params.append('bank_card_positive_img',scanForm.bank_card_positive_img[0].url);
      params.append('bank_card_back_img',scanForm.bank_card_back_img[0].url);
      params.append('id_card_hand_in_img',scanForm.id_card_hand_in_img[0].url);
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/scan/add',
        data: params
      }).then((res) => {
        _this.loading = false;
        if(res.data.code == 200) {
          _this.scanForm = false;
          _this.getscanInfo();
          _this.$message.success(res.data.data);
        } else {
          _this.$message.error(res.data.data);
        }
      })
    },
    getscanInfo() {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/scan/detail'
      }).then((res) => {
        if(res.data.data.length <= 0) {
          _this.showFlag = true;
        } else {
          _this.showFlag = false;
        }
        _this.scanDetails = res.data.data;
        if(_this.scanDetails.status == 0) {
          _this.scanDetails.statusTxt = '审核中';
        } else if (_this.scanDetails.status == 1) {
          _this.scanDetails.statusTxt = '审核通过';
          _this.label = '二维码下载';
          _this.qrFlag = !_this.qrFlag;
        } else if (_this.scanDetails.status == 2) {
          _this.scanDetails.statusTxt = '审核失败';
        }
        _this.scanDetails.created_at = _this.$transtime(_this.scanDetails.created_at);
      })
    },
    downloadQr(url,e) {
      var el = e.target.parentNode;
      var _this = this;
      var imgUrl = url;
      if(_this.browserIsIe()) {
        if (imgUrl.indexOf('data:image') > -1) {
            var blob = base64Img2Blob(imgUrl);
            window.navigator.msSaveBlob(blob, "下载.png");
        } else {
            DownLoadReportIMG(imgUrl);
        }
      } else {
        el.setAttribute('download',imgUrl);
        el.setAttribute('href',imgUrl);
      }
    },
    base64Img2Blob(code) {
      var parts = code.split(';base64,');
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    DownLoadReportIMG(imgPathURL) {
        // 如果隐藏IFRAME不存在，则添加
        if (!document.getElementById("IframeReportImg"))
            $('<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="DoSaveAsIMG();" width="0" height="0" src="about:blank"></iframe>').appendTo("body");
        if (document.all.IframeReportImg.src != imgPathURL) {
            // 加载图片
            document.all.IframeReportImg.src = imgPathURL;
        }
        else {
            DoSaveAsIMG();
        }
    },
    DoSaveAsIMG() {
        if (document.all.IframeReportImg.src != "about:blank")
            window.frames["IframeReportImg"].document.execCommand("SaveAs");
    },
    browserIsIe() {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            return true;
        }
        else {
            return false;
        }
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">	
  #scan
    form 
      width: 500px
    .btn-box
      text-align: center 
      margin: 10px 0
    .qr-box
      a
        display: inline-block
        text-align: center 
</style>


// WEBPACK FOOTER //
// src/components/scan/scan.vue